module.exports = __webpack_public_path__ + "media/images/press_kit/shoretime_light/email/top-light-small-8bdcf96791ead2254cf2bd17bb3889ec.png";